import { Card, CardContent } from "../ui/card";

const Footer = () => {
	return (
		<Card className="w-full max-w-md border-none shadow-none">
			<CardContent className="py-3 relative">
				<p className="absolute left-0 text-xs text-gray-500">
					Coûts estimés basés sur le tarif réglementé de vente de l'électricité.
				</p>
			</CardContent>
		</Card>
	);
};

export default Footer;
